<template>
  <el-container id="user-group">
    <el-header height="55px" class="header">
      <el-button-group>
        <el-button icon="el-icon-plus" @click="addAdminLayer=true" size="small">新建角色</el-button>
        <el-button icon="el-icon-refresh" @click="pageRefresh" size="small">刷新</el-button>
      </el-button-group>
    </el-header>
    <el-container>
      <el-aside class="aside" width="220px">
        <template v-if="groupList.length>0">
          <side-item
            :current-item="activeGroup"
            v-for="item in groupList"
            v-context-menu="contextMenu(item)"
            :data="item"
            :key="item.id"
            @currentChange="currentChange">
          </side-item>
        </template>
        <template v-if="groupList.length===0">
          <div style="width:100%;height:100px;text-align:center;line-height:100px;color:#555;font-size:15px">暂无数据</div>
        </template>
      </el-aside>
      <el-main class="main-content">
        <el-table
          class="admin-list-table"
          :data="adminList"
          stripe
          :header-row-style="{color:'#333333'}">
          <el-table-column
            label="头像"
            width="150">
            <template slot-scope="scope">
              <div class="headimg">
                <img :src="scope.row.headimg || $store.state.default_img_url">
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="姓名"
            width="120">
            <template slot-scope="scope">
              {{scope.row.name}}
            </template>
          </el-table-column>
          <el-table-column
            label="性别"
            width="120">
            <template slot-scope="scope">
              {{scope.row.gender}}
            </template>
          </el-table-column>
          <el-table-column
            label="邮箱"
            width="200">
            <template slot-scope="scope">
              {{scope.row.email}}
            </template>
          </el-table-column>
          <el-table-column
            label="手机号"
            width="200">
            <template slot-scope="scope">
              {{scope.row.phone}}
            </template>
          </el-table-column>
          <el-table-column
            label="工号"
            width="150">
            <template slot-scope="scope">
              {{scope.row.number}}
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="deleteAdmin(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pager"
          background
          :page-size="per_page"
          :page='page'
          layout="total, prev, pager, next, jumper"
          @current-change="currentPageChange"
          :total="total">
        </el-pagination>
      </el-main>
    </el-container>
    <!-- 新建管理员角色 layer -->
    <mask-layer v-model="addAdminLayer">
      <div class="add-admin">
        <el-form class="el-form" :model="addAdminForm" :rules="rules" label-width="80px">
          <h3>新建管理员角色</h3>
          <el-form-item label="角色名称" prop="name">
            <el-input v-model="addAdminForm.name" clearable placeholder="请输入集角色名称"></el-input>
          </el-form-item>
          <el-form-item label="角色代号" prop="code">
            <el-input v-model="addAdminForm.code" clearable placeholder="请输入角色代号"></el-input>
          </el-form-item>
          <el-form-item label="角色描述">
            <el-input type="textarea" v-model="addAdminForm.intrdution" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="addAdminForm.name===''" @click="addAdmin">立即创建</el-button>
            <el-button @click="addAdminLayer=false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </mask-layer>
    <!-- 更新管理员角色 layer -->
    <mask-layer v-model="updateGroupLayer">
      <div class="add-admin">
        <el-form class="el-form" label-width="80px">
          <h3>编辑管理员角色</h3>
          <el-form-item label="原始值">
            <p>{{selectGroup.name}}</p>
          </el-form-item>
          <el-form-item label="更改为" prop="name">
            <el-input v-model="updateGroupForm.name" clearable placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="updateGroupForm.name===''" @click="updateGroup">保存更改</el-button>
            <el-button @click="updateGroupLayer=false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </mask-layer>
  </el-container>
</template>
<script>
import request from '@/utils/request'
import SideItem from '@/components/SideItem/SideItem'
import TableComponent from '@/components/Table'
import MaskLayer from '@/components/MaskLayer'
export default {
  name: 'PlatformAdmin',
  components: {
    SideItem,
    TableComponent,
    MaskLayer
  },
  data () {
    return {
      groupList: [],
      activeGroup: '',
      per_page: 15,
      page: 1,
      total: 0,
      adminList: [],
      selectionList: [],
      addAdminLayer: false,
      addAdminForm: { // 新建管理员角色
        name: '', // 名称
        type: 0, // 类型
        code: '', // 代号
        description: '' // 描述
      },
      rules: { // 新建管理员角色验证规则
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      },
      selectGroup: '',
      updateGroupForm: {
        name: ''
      },
      updateGroupLayer: false
    }
  },
  watch: {
    selectGroup: function () {
      this.updateGroupForm.name = this.selectGroup.name
    }
  },
  mounted () {
    this.pageRefresh()
  },
  methods: {
    // 刷新页面 or 初始化数据
    pageRefresh () {
      let sendData = {
        type: 0
      }
      request({
        url: 'roles',
        method: 'get',
        params: sendData
      }).then(res => {
        this.groupList = res.data.list
        if (!this.activeGroup) {
          this.activeGroup = res.data.list[0] || ''
        }
        if (this.activeGroup) {
          this.activeGroupList()
        }
      })
    },
    // 获取当前选中管理员集合成员数据
    activeGroupList () {
      let sendData = {
        role: this.activeGroup.id,
        page: this.page,
        per_page: this.per_page
      }
      request({
        url: 'admins',
        method: 'get',
        params: sendData
      }).then(res => {
        this.adminList = res.data.list
        this.total = res.data.item_total
      })
    },
    // 管理员成员列表页码改变
    currentPageChange (e) {
      this.page = e
      this.activeGroupList()
    },
    // 新建管理员角色
    addAdmin () {
      request({
        url: 'roles',
        method: 'post',
        params: this.addAdminForm
      }).then(res => {
        this.pageRefresh()
        this.addAdminLayer = false
      })
    },
    // 更新管理员角色信息
    updateGroup () {
      let sendData = {
        attributes: {
          name: this.updateGroupForm.name
        },
        type: 'update_attribute'
      }
      request({
        url: 'roles/' + this.selectGroup.uuid,
        method: 'patch',
        data: sendData
      }).then(res => {
        this.pageRefresh() // 刷新页面
        this.updateGroupLayer = false // 隐藏编辑角色信息 layer
        this.selectGroup.name = this.updateGroupForm.name
      })
    },
    // 当前选择管理员列表
    currentChange (e) {
      this.activeGroup = e
      this.activeGroupList()
    },
    menuDeleteHandle (item) {
      this.$confirm('删除管理员角色 ' + item.name + '，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        request({
          url: 'roles/' + item.uuid,
          method: 'delete'
        }).then(res => {
          this.activeGroup = ''
          this.pageRefresh() // 刷新页面
        })
      }).catch(() => {})
    },
    // 右键菜单回调
    contextMenuCallback (item, type) {
      this.selectGroup = item
      switch (type) {
        case 'edit':
          this.updateGroupLayer = true
          break
        case 'delete':
          this.menuDeleteHandle(item)
          break
      }
    },
    // 右键菜单参数
    contextMenu (item) {
      return {
        data: item,
        callback: this.contextMenuCallback,
        menulist: [
          {
            label: '编辑',
            type: 'edit'
          },
          {
            label: '删除',
            type: 'delete'
          }
        ]
      }
    },
    deleteAdmin (row) {
      this.$confirm('从角色中删除该成员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: 'admins/' + row.uuid + '/roles/' + this.activeGroup.uuid,
          method: 'delete'
        }).then(res => {
          this.pageRefresh()
          this.$message.success('删除成功!')
        })
      }).catch()
    }
  }
}
</script>
<style lang="less" scoped>
#user-group {
  padding: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border: 1px solid #E4E7ED;
  .header {
    border-bottom: 1px solid #EBEEF5;
    line-height: 55px;
    padding: 0 10px;
  }
  .aside {
    border-right: 1px solid #EBEEF5;
    overflow-y:auto;
    box-sizing: border-box;
  }
  .main-content {
    overflow-y: auto;
    padding: 0 0 10px 0;
  }
  .add-admin {
    width: 700px;
    .el-form {
      width: 600px;
      margin: 10px auto;
      h3 {
        color: #333333;
        text-align: center;
        margin-bottom: 15px;
      }
    }
  }
  .admin-list-table {
    .headimg {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      overflow: hidden;
      background-color: #dddddd;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .pager {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/admin/PlatformAdmin.vue